import {usePlantConfig} from '@domain/shifthandover'
import {CircularProgress} from '@mui/material'
import {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type PlantConfigContainerWrapperProps = {
  plantId: string
  children: ReactNode
}

export const PlantConfigContainerWrapper = ({
  plantId,
  children
}: PlantConfigContainerWrapperProps) => {
  const {
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)

  const {data: config, isLoading, error} = usePlantConfig({plantId, language})

  if (isLoading) {
    return <CircularProgress />
  }

  if (error || !config) {
    throw new Error('Plant configuration is required to render the dashboard')
  }

  return <>{children}</>
}
